<template>
  <div class="v-slider">
    <img :src="currentSlide.img" :alt="currentSlide.heading">
    <div class="v-slide-text">
      <h2>{{ currentSlide.heading }}</h2>
      {{ currentSlide.text }}
    </div>
    <div class="v-slide-controls">
      <p class="v-slide-controls__counter">{{ slideCounter }}</p>
      <button class="v-slide-controls__btn prev" @click="prev" >
        <svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>
      </button>
      <button class="v-slide-controls__btn next" @click="next" >
        <svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      slideNumber: 0
    };
  },
  mounted() {
    this.slideNumber = this.currentNumber;
  },
  props: ["slides", "currentNumber"],
  computed: {
    currentSlide() {
      return this.slides[Math.abs(this.slideNumber)];
    },
    slideCounter() {
      return `${this.slideNumber + 1} / ${this.slides.length}`;
    }
  },
  methods: {
    next() {
      if (this.slideNumber < this.slides.length - 1) {
        this.slideNumber++;
      } else {
        this.slideNumber = 0;
      }
    },
    prev() {
      if (this.slideNumber > 0) {
        this.slideNumber--;
      } else {
        this.slideNumber = this.slides.length - 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-slider {
  background: #fff;
  box-shadow: 0 3px 16px hsla(243, 100%, 2%, 0.9);
  padding: 1rem 1rem 0.5rem 1rem;
  width: 70%;
  max-width: 500px;

  @media screen and (max-height: 440px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(2, max-content);
    padding: 1rem 1rem 1rem 1rem;
  }
}

.v-slider img {
  max-width: 100%;
  width: 300px;

  @media (min-width: 550px) {
    width: 500px;
  }

  @media screen and (max-height: 440px) {
    grid-row: span 2;
  }
}

.v-slide-text {
  max-width: 500px;
  font-size: 0.875rem;
  line-height: 1.3;

  h2 {
    margin: 0.2rem 0;
  }

  @media (min-width: 550px) {
    font-size: 1rem;

    h2 {
      margin: 1rem 0;
    }
  }

  @media screen and (max-height: 440px) {
    padding-left: 0.5rem;
    grid-row: span 1;
    font-size: 0.875rem;
  }
}

.v-slide-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem 0 0 0;

  @media screen and (max-height: 440px) {
    grid-column: span 1;
    grid-row: span 1;
    align-self: end;
  }
}

.v-slide-controls__btn {
  box-sizing: border-box;
  text-align: center;
  margin: 0;
  height: 42px;
  width: 42px;
  color: #fff;
  border: 5px solid #145ced;
  background: #145ced;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #fff;
    color: #145ced;
  }

  &:hover .arrow {
    fill: #145ced;
  }

  &:focus {
    outline: none;
  }

  &.prev {
    margin-right: 8px;
  }
}

.v-slide-controls__btn svg {
  height: 100%;
}
.v-slide-controls__btn .arrow {
  fill: #fff;
}

.v-slide-controls__counter {
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/Slider.vue